import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import Card from '../../Card';
import useVideo from '../../../store/video/useVideo';
import DivContainer from './VideoCardList.styled';

const VideoCardList = ({ videos, getVideoPath }) => {
  const { push } = useHistory();
  const { setCurrentVideo } = useVideo();

  function handleOnClick(video) {
    setCurrentVideo(video);
    push(getVideoPath(video));
  }

  return (
    <DivContainer>
      {videos.map((video) => (
        <Card
          key={video.id}
          img={video.image}
          title={video.title}
          description={video.description}
          publishTime={video.publishTime}
          onClick={() => handleOnClick(video)}
        />
      ))}
    </DivContainer>
  );
};

VideoCardList.propTypes = {
  videos: PropTypes.array.isRequired,
  getVideoPath: PropTypes.func.isRequired,
};

export default VideoCardList;
